export const TABLE_RESULT_ADD = "@table/TABLE_RESULT_ADD";
export const TABLE_CLEAR = "@table/TABLE_CLEAR";